import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PlacementSearchComponent } from '../../placement-search/placement-search.component';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { SessionUserHashManagerService } from '../../_services/session-user-hash-manager/session-user-hash-manager.service';
import { PlacementSearchDataHelperService } from '../../_helpers/placement-search-data-helper/placement-search-data-helper.service';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';

@Component({
    selector: 'app-client-bookings',
    templateUrl: './client-bookings.component.html',
    styleUrls: ['./client-bookings.component.css'],
    standalone: false
})
export class ClientBookingsComponent implements OnInit, OnDestroy {
  @ViewChild("placementSearch", { static: false }) placementSearchComponent: PlacementSearchComponent;

  public clientId: string;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public themeService: ThemeService,
    private featureHelperService: FeatureHelperService,
    private router: Router,
    private route: ActivatedRoute,
    private userHashManager: SessionUserHashManagerService,
    public searchDataHelper: PlacementSearchDataHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService
    ) { 
      this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
        if (!params['clientId']) {
          this.router.navigate(['/login']);
        } else {
          this.userHashManager.checkUserForExternal();

          this.themeService.setActiveTheme('LEAP');

          let featureList = new Array<string>();
          featureList.push("BookingSearchView");

          let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

          if (!currentUserFeatures.filter(f => f.feature === "BookingSearchView")[0].enabled) {
            console.error("User does not have the required permissions to view Booking Search");
            this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
            this.authenticationStateHelper.unauthorizedToken = true;
          }

          this.clientId = params['clientId'];
         
          setTimeout(() => {
            this.searchDataHelper.clientNameOrId = this.clientId;
            // placement-search binds directly to searchDataHelper.placements, so existing
            // results render automatically; only trigger a fetch when there are none.
            if (!(this.searchDataHelper.placements && this.searchDataHelper.placements.length > 0)) {
              this.placementSearchComponent.searchPlacements();
            }
          }, 100);
          
        }
      });
    }

  ngOnInit() {
    
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
